import { render, staticRenderFns } from "./ModalLightTable.vue?vue&type=template&id=7271effd&scoped=true"
import script from "./ModalLightTable.vue?vue&type=script&lang=js"
export * from "./ModalLightTable.vue?vue&type=script&lang=js"
import style0 from "./ModalLightTable.vue?vue&type=style&index=0&id=7271effd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7271effd",
  null
  
)

export default component.exports